import React from 'react';
import {ILauncherServiceFactory} from './services/launcher-service-factory.interface';





export interface ILauncherContext {
    services: ILauncherServiceFactory
}

export const LauncherContext = React.createContext<ILauncherContext>(null);

export const LauncherContextProvider = LauncherContext.Provider;
export const LauncherContextConsumer = LauncherContext.Consumer;
